module.exports = "/static/assets/ba812d61e4b104a25ef999ac7d91bf3d.png";